import { http } from './client';
import type { Bot, PageResult, PromptVersion, PromptVersionSummary } from './types';

export interface PromptVersionsPage extends PageResult<PromptVersionSummary> {
  activeVersion: number | null;
}

function botPath(botId: string): string {
  return `/v1/org/bots/${encodeURIComponent(botId)}/prompt-versions`;
}

export const promptVersionsApi = {
  async list(botId: string, params: { limit?: number; cursor?: string } = {}): Promise<PromptVersionsPage> {
    const res = await http.get<PromptVersionsPage>(botPath(botId), { params });
    return res.data;
  },
  async get(botId: string, version: number): Promise<PromptVersion> {
    const res = await http.get<PromptVersion>(`${botPath(botId)}/${version}`);
    return res.data;
  },
  async restore(botId: string, version: number, note?: string): Promise<Bot> {
    const res = await http.post<Bot>(`${botPath(botId)}/${version}/restore`, note ? { note } : {});
    return res.data;
  },
};
